export default __webpack_public_path__ + "static/media/031-hologram.03525560.svg";